import React from 'react';

import Services from '@totem/components/settings/sections/services/Services';
import ContentLayout from '@totem/components/ui_components/page/ContentLayout';

const AccountServicesPage = () => {
  return (
    <ContentLayout>
      <Services />
    </ContentLayout>
  );
};

export default AccountServicesPage;
